import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Stepper } from "../../../components";
import {
  GetStartedStep,
  ChooseAssessment,
  CustomizeStep,
  ConfigureLaunch,
  CreateCampaign,
} from "../";
import { campaignsLimit, LocalStorageService } from "../../../services";
import { useNavigate } from "react-router-dom";
import authHeader from "../../../services/auth/auth-header";
import { getApi } from "../../../services/helpers/apiCall";

import ROUTES from "../../constants/routes";

// get step data from redux main state
const homeData = (state) => state.home;

// get step data from redux main state
const authData = (state) => state.auth;

// get step data from redux main state
const dashboardData = (state) => state.dashboard;

function Home() {
  let client = useSelector(authData);
  const data = useSelector(homeData);
  const dashboard = useSelector(dashboardData);
  let currentStep = data && data.step;
  let navigate = useNavigate();

  // if (data && data.clearAll) {
  //   LocalStorageService.remove("step1");
  //   LocalStorageService.remove("step2");
  //   LocalStorageService.remove("step3");
  //   LocalStorageService.remove("step4");
  // }

  useEffect(() => {
    let { companyId } = client?.client;
    let apiCallRequest = {
      url: `/companies/${companyId}`,
      data: null,
      config: {
        headers: authHeader(),
      },
    };
    getApi(apiCallRequest).then((res) => {
      let campaigns =
        dashboard && dashboard.campaigns && dashboard.campaigns.length;
      let name = res.data.bucket_name;
      if (campaigns > 0) {
        if (!(campaignsLimit[name] && campaignsLimit[name].limit > campaigns)) {
          navigate(`${ROUTES.DASHBOARD}`);
        }
      }
    });
  }, [dashboard]);

  return (
    <div>
      <Stepper current={currentStep}>
        <div className="flex justify-center pt-20 mt-[-50px] bg-[#F5F6FA]">
          {currentStep === 1 ? (
            <GetStartedStep />
          ) : currentStep === 2 ? (
            <ChooseAssessment />
          ) : currentStep === 3 ? (
            <CustomizeStep />
          ) : currentStep === 4 ? (
            <ConfigureLaunch />
          ) : currentStep === 5 ? (
            <CreateCampaign />
          ) : null}
        </div>
      </Stepper>
    </div>
  );
}

export default Home;
